import React, { useState } from "react";
import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";
import { Alert, MenuItem } from "@mui/material";
import TranslationWrapper from "../../../../../../components/TranslationWrapper/TranslationWrapper";
import FormSelect from "../../../../../../components/Forms/FormSelect";

function FontFamily({ name, fonts, required }: JSInputProps) {
  const [selectedFont, setSelectedFont] = useState("");

  const error = !fonts.find((f) => f === selectedFont) && selectedFont;

  return (
    <>
      {error ? (
        <Alert severity={"warning"} style={{ marginBottom: "8px" }}>
          <TranslationWrapper
            tDefault={
              "Confirm that this font is desired, it is present in customfonts nor is it the default fontFamily. The selected font is:"
            }
            tKey={"vestiging.tab.customComponents.warning.checkFontExists"}
          />
          <p style={{ textDecoration: "underline", fontWeight: "bold" }}>{selectedFont}</p>
        </Alert>
      ) : null}
      <FormSelect
        name={name}
        nullable={true}
        onSelect={(value: string) => {
          setSelectedFont(value);
        }}
        options={[
          <MenuItem key={"Default"} value={""}>
            Default
          </MenuItem>,
          ...fonts.map((fontName) => {
            return (
              <MenuItem key={fontName} value={fontName}>
                <span style={{ fontFamily: fontName }}>{fontName}</span>
              </MenuItem>
            );
          }),
        ]}
        rules={{ required }}
      />
    </>
  );
}

export const JSFontFamilyComponent: JSInputComponent = {
  Component: FontFamily,
  handlesCssProperties: ["fontFamily"],
};
